export default __webpack_public_path__ + "static/media/product_03.60eff46e.png";